export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4 animate-rise">
    <div>
      {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
      <h1 className="font-display text-4xl font-bold uppercase tracking-tight text-zinc-900 sm:text-5xl">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);
